import singleTransactionFactory from '../transactions/single-transaction/single-transaction-factory';

export default singleTransactionFactory({
  assetCategory: 'mmInstruments',

  transactionFragmentExtend: {
    type: true,
    amount: true,
  },
});
